import React, { useState, useEffect, useMemo } from 'react';
import { FlatList, ScrollView, SectionList, View } from 'react-native'

import api from "@/utils/api"
import tw from '@/styles/tailwind';
import Text from '@/components/Text';
import { Image } from 'expo-image';
import { useQuery } from '@tanstack/react-query';

import IconButton from '@/components/IconButton';
import { currency } from '@/screens/Community/Admin/Fees/Reports/ReportsSection';
import { MonthSelector, MonthSelectorDropdown, MonthSelectorModal } from '@/components/Forms/MonthSelector';
import { useNavigation } from '@react-navigation/native';
import useActiveAdminCommunity from '@/hooks/useActiveAdminCommunity';
import PaymentRequestRow from '@/screens/Vinte/PaymentRequests/components/PaymentRequestRow';


export default function PaymentRequestsSection() {
  const { communityId } = useActiveAdminCommunity()
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [showMonthSelectorModal, setShowMonthSelectorModal] = useState(false);

  const monthISO = selectedMonth.toISOString().split("T")[0]

  const { isInitialLoading, error, data: paymentRequests, refetch } = useQuery({
    queryKey: ['vinte.payment-requests', communityId, monthISO],
    queryFn: () => api.get(`/vinte/payment-requests?community_id=${communityId}&month=${monthISO}`).then(response => response.data),
  })

  const periodTotal = useMemo(() => {
    return paymentRequests?.reduce((acc, cur) => acc + cur.amount, 0)
  }, [paymentRequests])


  const navigation = useNavigation()

  return (

    <View style={tw`flex-1`}>
      {/* <View style={tw` bg-secondary`}>
        <View style={tw`bg-white px-5 py-4 mx-5 my-5 rounded-xl`}>
          <View style={tw`row justify-between mb-4`}>
            <Text style={tw`text-secondary text-base font-500`}>Total de gastos</Text>
            
            <MonthSelectorDropdown
              selectedDate={selectedMonth}
              onPress={() => setShowMonthSelectorModal(true)}
              style={{ container: `w-40 py-2`}}
            />
          </View>

          <Text style={tw`text-center text-2xl font-500 text-gray-400`}>{currency(periodTotal)}</Text>
        </View>
      </View> */}


      {/* Acá van los filtros */}

      {
        isInitialLoading &&
          <Text style={tw`my-8 text-lg text-center text-gray-400`}>Cargando...</Text>
      }

      {
        showMonthSelectorModal &&
          <MonthSelectorModal
            onRequestClose={() => setShowMonthSelectorModal(false)}
            selectedDate={selectedMonth}
            onChange={date => {
              setShowMonthSelectorModal(false)
              setSelectedMonth(date)
            }}
          />
      }

      {
        paymentRequests?.length == 0 &&
          <Text style={tw`mt-25 text-lg text-center text-gray-400`}>Sin solicitudes registradas</Text>
      }

      <FlatList
        data={paymentRequests}
        contentContainerStyle={tw`pt-2 pb-14`}
        renderItem={({ item }) => <PaymentRequestRow paymentRequest={item} canReview={false} />}
        keyExtractor={(item) => item.uuid}
      />


      <IconButton
        title={"Solicitud Pago"}
        color='secondary'
        textColor='white'
        style={tw`absolute right-0 bottom-0 w-45% rounded-t-2xl rounded-b-0 py-3`}
        onPress={() => {
          navigation.navigate("Vinte.PaymentRequests.New",{
            onPaymentRequestCreated: () => {
              navigation.goBack()
              refetch()
            }
          })
        }}
      />


      {/* {
        showNewExpenseModal &&
          <NewExpenseModal
            communityId={communityId}
            onRequestClose={() => setShowNewExpenseModal(false)}
            onExpenseCreated={() => {
              setShowNewExpenseModal(false)
              refetch()
            }}
            visible
          />
      } */}
    </View>
  )
}